/**
 * PATH: packages/ui/src/kanban/components/lane/useLaneMenu.ts
 * FILE_ID: UI-KANBAN-LANE-MENU-HOOK-001
 * PURPOSE: Lane overflow-menu open state and the in-lane search query.
 * ROLE IN ARCHITECTURE: State hook for LaneHeader. The query is local to
 *   this lane instance, including each Split-view band column.
 * MAIN EXPORTS: useLaneMenu
 * NON-RESPONSIBILITIES: Does not filter cards. The lane view-model does.
 */
import { useRef, useState } from 'react'

import { useCloseOnOutsidePointer } from '../../../hooks/useCloseOnOutsidePointer'

export function useLaneMenu() {
  const [menuOpen, setMenuOpen] = useState(false)
  const [laneSearch, setLaneSearch] = useState('')
  const menuRef = useRef<HTMLDivElement>(null)

  // Reused from: packages/ui/src/hooks/useCloseOnOutsidePointer.ts (useCloseOnOutsidePointer)
  useCloseOnOutsidePointer(menuOpen, () => setMenuOpen(false), [menuRef])

  return { menuOpen, setMenuOpen, laneSearch, setLaneSearch, menuRef }
}
